module.exports = __webpack_public_path__ + "img/story014.7ec48648.webp";